import { render, staticRenderFns } from "./ActionMealRemove.vue?vue&type=template&id=ac8acbaa&scoped=true"
import script from "./ActionMealRemove.vue?vue&type=script&lang=js"
export * from "./ActionMealRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8acbaa",
  null
  
)

export default component.exports